import React from "react";
import PropTypes from "prop-types";
import { StyledDialog, StyledDialogTitle } from "./_.styled";
import { DialogTitleActions } from "discover.medical.react-component-library";

export default function DialogWindow({
  windowMessage,
  pageType,
  isOpened,
  handleClose,
}) {
  return (
    <StyledDialog
      isOpen={isOpened}
      pageType={pageType}
      onRequestClose={handleClose}
      maxWidth="md"
      data-testid="DialogWindow"
    >
      <StyledDialogTitle>
        <DialogTitleActions onRequestClose={handleClose} isFloating />
      </StyledDialogTitle>
      <>{windowMessage}</>
    </StyledDialog>
  );
}

DialogWindow.propTypes = {
  windowMessage: PropTypes.node.isRequired,
  isOpened: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
